import { useRef } from 'react'
import { SectionData } from '@playbooks/action-cards-utils/src'

import { useAppContext } from '../contexts/AppContext'
import useMountEffect from './useMountEffect'

export default function useOnSectionReady(data: SectionData) {
  const { onSectionReady } = useAppContext()
  const sectionRef = useRef<HTMLDivElement>(null)

  useMountEffect(() => {
    onSectionReady?.(sectionRef.current!, data)
  })

  return sectionRef
}
